import type { CostProjectionDataType, MSADataType } from "types/DataTypes";
import { serviceToInvoiceableEntity } from "components/Invoicing/invoiceAdapter";
import InvoiceContainer from "components/Invoicing/InvoiceContainer";

/**
 * InvoiceCMS component displays all invoices for a service with CMS invoices marked accordingly
 */
const InvoiceCMS = ({
  service,
}: {
  service: MSADataType | CostProjectionDataType;
}) => {
  const entity = serviceToInvoiceableEntity(service);

  if (!entity) return <div>Could not process service data</div>;

  return (
    <div className="invoice-cms">
      <InvoiceContainer
        entity={entity}
        config={{
          showHistory: true,
          showCMS: true,
          filterCMSInvoices: false,
        }}
        invoiceType="future_medical"
      />
    </div>
  );
};

export default InvoiceCMS;
